import React from 'react';
import { motion } from 'framer-motion';

const AutomataToAnimatronics = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl font-bold mb-6">Early Foundations: Automata to Audio-Animatronics</h2>
          <p className="text-lg leading-relaxed">
            The earliest roots of animatronics can be traced to automata—intricate mechanical devices designed to mimic humans or animals. One of the most famous examples is the Silver Swan from the 18th century, built by John Joseph Merlin. These clockwork wonders sparked a fascination for creating lifelike motion through mechanical means.
          </p> 
          <p className="text-lg leading-relaxed">
            Fast-forward to the mid-20th century, when Walt Disney and his team elevated the concept of mechanical figures into full-blown storytelling. The mechanical birds of Walt Disney's Enchanted Tiki Room (1963) were an early preview of the advanced, lifelike human figures introduced soon after—like Great Moments with Mr. Lincoln at the 1964 New York World's Fair. This breakthrough spurred the development of countless attractions where robots could "talk," sing, and even deliver a memorable scare.
          </p> 
          <p className="text-lg leading-relaxed">
            The term "Audio-Animatronics" was first used commercially by Disney in 1961, and was filed as a trademark in 1964, before being registered in 1967.
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <img
            src="/images/automata-history.webp"
            alt="Historical automata and early animatronic figures"
            className="w-full rounded-lg"
          />
        </motion.div>
      </div>
    </section>
  );
}

export default AutomataToAnimatronics;